(function () {
  function getCartAddUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    return root.replace(/\/?$/, '/') + 'cart/add.js';
  }

  function getCartUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    return root.replace(/\/?$/, '/') + 'cart';
  }

  function handleAddToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var label = button.querySelector('.offer-comparison__add-to-cart-label');
    var originalText = label ? label.textContent : '';

    button.disabled = true;
    button.classList.add('is-loading');
    if (label) label.textContent = 'Ajout en cours…';

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Erreur lors de l’ajout au panier');
          });
        }
        return response.json();
      })
      .then(function () {
        // Redirection vers le panier pour poursuivre l'achat
        window.location.href = getCartUrl();
      })
      .catch(function (error) {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (label) label.textContent = originalText;
        // eslint-disable-next-line no-alert
        alert(
          'Une erreur est survenue : ' +
            error.message +
            '. Merci de réessayer.'
        );
      });
  }

  function initAll() {
    var buttons = document.querySelectorAll('[data-add-to-cart]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        handleAddToCart(button);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();